import type { ProtocolMetadata } from "@/types";
import React, { useMemo } from "react";

import HomepageSection from "@/components/Explore/Section";
import HomepageVaultSlider from "@/components/Explore/Vaults/Slider";
import SliderLoader from "@/components/Explore/Vaults/SliderLoader";
import VaultCard from "@/components/Explore/Vaults/Card";

import useProtocolVaults from "@/hooks/api/useProtocolVaults";

interface ProtocolFeaturedVaultsProps {
  singleProtocol?: ProtocolMetadata;
  isLoadingProtocol?: boolean;
}

export default function ProtocolFeaturedVaults({ singleProtocol, isLoadingProtocol = true }: ProtocolFeaturedVaultsProps) {
  const { data, isLoading } = useProtocolVaults(singleProtocol?.id, isLoadingProtocol);

  const vaults = useMemo(() => {
    return (data ?? []).filter(vault => vault.visibility === "featured").sort((a, b) => b.vault_statistics.displayTvl - a.vault_statistics.displayTvl);
  }, [data]);

  return (
    (isLoading || vaults.length > 0) && (
      <div className="my-12 px-12">
        <HomepageSection contentClassName="mt-6 md:mt-6" subtitle="FEATURED VAULTS">
          {!isLoading ? (
            <HomepageVaultSlider rows={2}>
              {vaults?.map(vault => (
                <VaultCard
                  skipApyMultiplier
                  key={`base-slider-${vault.id}`}
                  data={{
                    ...vault,
                    protocol: undefined,
                    chain: {
                      ...vault.chain,
                      logo: `${vault.chain.logo_url}`,
                    },
                    rewards: vault.rewards ?? [],
                    apy: vault.vault_statistics.displayApy,
                    tvl: vault.vault_statistics.displayTvl,
                    hasSuperPool: (vault.super_pools ?? []).length > 0,
                    token: {
                      logo: vault.assets[0].image,
                      name: vault.assets[0].name,
                    },
                  }}
                />
              ))}
            </HomepageVaultSlider>
          ) : (
            <SliderLoader rows={2} />
          )}
        </HomepageSection>
      </div>
    )
  );
}
